module.exports = __webpack_public_path__ + "static/media/nuCrop browse.d6778abb.JPG";